import { apiClient } from "../api";

/**
 * Servicio de contacto (formulario de contacto)
 */

export const enviarContacto = async (formData) => {
  const { data } = await apiClient.post("contacto", formData);
  return data;
};
